import { FacilityService } from './../../../../core/services/facility.service';
import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getForwarderByPermission, getRoleScopeColumnMappings, isNullOrEmpty, getBrandByPermission, getCustomerByPermission, getDeptByPermission, getOrgIdByPermission, getTenantByPermission, laaSFormatString } from 'src/app/core/utils/common-functions';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { ForwarderService } from '../../../transport-operation/services/forwarder.service'
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { ConfirmEventType, MenuItem } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';


@Component({
  selector: 'forwarder-setting-rmb',
  templateUrl: './forwarder-setting-rmb.component.html',
  styleUrls: ['./forwarder-setting-rmb.component.scss']
})
export class ForwarderSettingRmbComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string = UserPreferenceConstants.RMBForwarderSetting;
  viewPermissionCode: PermissionConstants = PermissionConstants.ViewForwarderSetting;
  editPermissionCode: PermissionConstants = PermissionConstants.EditForwarderSetting;
  @ViewChild('dataTable') dataTable!: DataTableComponent;


  isDataTableOpen: boolean = false;
  isSearchFormOpen: boolean = true;
  isLoading: boolean = false;
  searchForm: FormGroup;
  facilityOptions: any[] = [];
  facilityList: any[] = [];
  forwarderOptions: any[] = []
  brandOptions: any[] = [];
  consigneeKeyOptions: any[] = [];
  letterOrgIdOptions: any[] = [];
  workingDayOptions: any[] = ['ALL','1','2','3','4','5'];
  pickupLocationCodeOptions: any[] = [];
  selectedRows: any[] = [];
  userOptions: any[] = [];

  dataRows: any[] = [];
  columns: any[];

  pageInfo: PageInfo = {
   pageSize: 5,
   pageIndex: 0,
   totalRecords: 0,
   totalPages: 0,
  };
  sortOrder: SortOrder = {
  property: "SeqNo",
  direction: -1
  };

  forwarderFile: any = null;
  selectedFileName: string = '';
  displayImportDialog: boolean = false;
  isImportDialogLoading: boolean = false;
  isFileSelected: boolean = false;
  tempCountryOptions: any[] = [];

  constructor(
    injector: Injector,
      private formBuilder: FormBuilder,
      private dropdownOptionService: DropdownOptionsService,
      private forwarderService: ForwarderService,
      private facilityService: FacilityService,
      private addressMaintainanceService: AddressMaintainanceService,
      private commonDataService: CommonDataService,
      private dOService: DeliveryOrderService,
      private localStorageService: LocalStorageService
    ) {
    super(injector);
    this.searchForm = this.formBuilder.group({
      facility: null,
      forwarderCodeList: [],
      letterHeadOrgIdList: [],
      workingDay: null,
      brand: null
    });

    this.columns = [
      { field: 'facility', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.Facility', sort: true },
      { field: 'letterHeadOrgId', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.LetterHeadOrgId', sort: true },
      { field: 'forwarderCode', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.ForwarderCode', sort: true },
      { field: 'workingDay', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.WorkingDay', sort: true },
      { field: 'consigneeKey', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.ConsigneeKey', sort: true },
      { field: 'brand', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.Brand', sort: true },
      { field: 'inHouseNo', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.InHouseNo', sort: true },
      { field: 'pickupLocationCode', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.PickupLocationCode', sort: true },
      { field: 'createDt', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.CreateDt', dataType: 'date', sort: true },
      { field: 'createUser', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.CreateUser', sort: true },
      { field: 'updateDt', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.UpdateDt', dataType: 'date', sort: true },
      { field: 'updateUser', header: 'ForwarderSetting.RMBRecommendForwarder.TableColumn.UpdateUser', sort: true },
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        if (this.facilityOptions.some(x => x.value == this.laasSetting.facility)) {
          this.facilityList = [this.laasSetting.facility]
        }
      }
    });

    this.dropdownOptionService.getLetterOrgOptions().subscribe({
      next: (result: any[]) => {
        this.letterOrgIdOptions = result.map(x => ({
          label: x.legalEntityOUName,
          value: x.legalEntityOUCode,
        }));
      }
    })

    this.dropdownOptionService.getForwarderOptions().subscribe({
      next: (result: any[]) => {
        this.forwarderOptions = result.map(x => ({label: x.optionDesc, value: x.optionCode}))
      }
    });

    this.dropdownOptionService.getBrandOptions(1).subscribe({
      next: (options: any[]) => {
        this.brandOptions = options.map(x => ({ label: x.brandName, value: x.brandName }));
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result: []) => {
        this.consigneeKeyOptions = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.facilityService.getFacilityPickupLocationCode(this.laasSetting.facility).subscribe({
      next: (result: any[]) => {
        this.pickupLocationCodeOptions = result.map(x => ({
          label: x.optionCode + ' - ' + x.optionDesc,
          value: x.optionCode,
        }));
      }
    })

    this.dropdownOptionService.getUserOptions().subscribe({
      next: (options: any[]) => {
        this.userOptions = options.map(x => ({ label: x.userName, value: x.uuid}));
      }
    });

  }

  searchBtnClick(): void {
    this.dataTable.loading = true;
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);
    this.dataTable.selectedRow = [];
    this.selectedRows = [];
    this.isLoading = true;
    this.searchData();
  }

  searchData(): void {
    const params = {
      ...this.searchForm.value,
      facility: this.laasSetting.facility,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    }
    console.log('params',params);

    this.forwarderService.searchRmbRecommendForwarder(params)
     .pipe(finalize(()=>{this.dataTable.loading = false}))
     .subscribe({
      next: response => {
        console.log('response',response);
        this.dataRows = response.content;
        this.pageInfo.totalRecords = response.totalElements;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.dataTable.updateTableData(this.dataRows);
      },
      error: (response) => {
        this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail') + response.status);
        this.dataRows = [];
      },
      complete: () => {
        this.isDataTableOpen = true;
        this.isSearchFormOpen = false;
      }
    })
  }

  resetBtnClick() {
    this.searchForm.reset();
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchBtnClick();
  }

  saveData(savedDataBean: DataTableSavedBean): void {
    this.dataTable.loading = false;
    const saveDataRequest = {
      insertList: savedDataBean.newList,
      updateList: savedDataBean.updatedList,
    };
    console.log('saveDataRequest', saveDataRequest);

    this.forwarderService.saveRmbRecommendForwarder(saveDataRequest)
    .pipe(finalize(()=>this.searchBtnClick()))
    .subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchBtnClick();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async (response) => {
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        this.toastService.error(msg);
      },
      complete: () => {
      }
    })
  }

  deleteBtnClick() {
    this.dataTable.checkedRows = this.selectedRows;
    this.dataTable.deleteRowEvent();
    this.dataTable.checkedRows = this.selectedRows;

    let deleteSeqNoList = this.selectedRows.filter(x => x.seqNo).map(x => x.seqNo);

    if (deleteSeqNoList != null && deleteSeqNoList.length > 0){
      this.confirmationService.confirm({
        message: this.translateService.instant('將移除資料庫資料，請問要刪除嗎?'),
        header: this.translateService.instant('系統資訊'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.loader.show();
          this.forwarderService.deleteRmbRecommendForwarder(deleteSeqNoList)
          .subscribe({
            next: result => {
              this.toastService.success('資料刪除完成!!');
              this.searchBtnClick();
            },
            error: async response => {
              this.loader.hide();
              this.dataTable.loading = false;
              var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
              var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
              this.toastService.error(msg);
            },
            complete: () => {
              this.logger.info('complete...');
              this.loader.hide();
              this.dataTable.loading = false;
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      });
    }
  }

  createRow(rowData: any): void {
    rowData.facility = this.laasSetting.facility;
    rowData.updateUser = this.userProfile.uuid;
    rowData.updateDt = new Date();
    rowData.createUser = this.userProfile.uuid;
    rowData.createDt = new Date();
  }

  createNewRow = (rowId: number) => {
    return {
      seqNo: null,
      facility: null,
      letterHeadOrgId: null,
      workingDay: null,
      forwarderCode: null,
      brand: null,
      consigneeKey: null,
      InHouseNo: null,
      PickupLocationCode: null,
      createUser: null,
      createDt: null,
      updateUser: null,
      updateDt: null,
      rowId: rowId
    }
  }

  dataInputValid = (rowData: any): boolean => {
    if(rowData){
      console.log('dataInputValid rowData', rowData)
      if(isNullOrEmpty(rowData.letterHeadOrgId) || isNullOrEmpty(rowData.forwarderCode) || isNullOrEmpty(rowData.workingDay)){
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }

      rowData.updateUser = this.userProfile.uuid;
      rowData.updateDt = new Date();
    }
    return true;
  }

  get language(): string {
    return this.localStorageService.getItem(GlobalConstants.languageKey);
  }

  exportBtnClick() {

    const params = {
      ...this.searchForm.value,
      facility: this.laasSetting.facility
    }
    console.log('export RmbRecommendForwarder params',params)

    this.forwarderService.exportFileByRecommendForwarderType(params, 'rmb', this.language)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: result => {
          if (result == null || result.size === 0) {
            this.toastService.info(this.translateService.instant('Common.Toast.NoDataFound'));
            this.loader.hide();
            return;
          }
          const file = result;
          const url = URL.createObjectURL(file);
          const a: any = document.createElement('a');
          file.name = 'RmbRecommendForwarder.xlsx';
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  showImportDialog(): void {
    this.displayImportDialog = true;
  }

  onFileSelected(event: any): void {
    this.forwarderFile = event.target.files[0];
    if (this.forwarderFile) {
      this.isFileSelected = true;
      this.selectedFileName = this.forwarderFile.name;
      event.target.value = '';
    }
  }

  uploadFile(): void {
    console.log('import facility', this.facilityList)
    if (this.facilityList == null) {
      this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.ImportFacilityEmpty'));
    }

    this.isImportDialogLoading = true;
    this.forwarderService.uploadRecommendForwarderFile(this.forwarderFile, 'rmb', this.facilityList).subscribe({
      next: rsp => {
        console.log('uploadFile rsp={}',rsp)
        if (rsp.flag == 'F') {
          this.toastService.success(this.translateService.instant('ForwarderSetting.Msg.Uploadsuccess'));
        }
        if (rsp.flag == 'E') {
          this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
        }
      },
      error: rsp => {
        console.log('uploadFile error', rsp);
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
        if (rsp.error) {
          this.toastService.error(rsp.error.errorMsg);
          let errorRowData = rsp.error.datas.join(',').replace(/,/g, '\r\n');
          this.toastService.error(errorRowData);
          return;
        }
        this.toastService.error(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
      },
      complete: () => {
        this.displayImportDialog = false;
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
      }
    });
  }

  downloadTemplateBtn(): void {
    var fileType = 'RmbRecommendForwarderTemplate';
    var fileName = 'Rmb推薦貨代範本';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        console.log('result',result)
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };
        console.log('searchObj',searchObj)
        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' });

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsx';
          link.click();
        });
      },
      error: err => {
        console.log('error',err)
      }
    });
  }

    onCustomerListLoaded(list: any[]) {
    this.consigneeKeyOptions = list;
  }

  onTableConsigneeChange(selectedItem: any, rowData: any) {
      if (!selectedItem || !selectedItem.label) {
      rowData.consigneeName = null;
      return;
    }
    const label = selectedItem.label;
    const name = label.substring(label.indexOf('-') + 1).trim();
    rowData.consigneeName = name;
  }
}
